import { render, staticRenderFns } from "./ServerMonitoring.vue?vue&type=template&id=66c301de&scoped=true"
import script from "./ServerMonitoring.vue?vue&type=script&lang=js"
export * from "./ServerMonitoring.vue?vue&type=script&lang=js"
import style0 from "./ServerMonitoring.vue?vue&type=style&index=0&id=66c301de&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66c301de",
  null
  
)

export default component.exports